import * as THREE from 'three';
import dataStore from '../../../data/data';

function Align(landmarks, target='peer') {
  const setData = dataStore.setState;
  if (!landmarks?.length) return;

  const faceTop = new THREE.Vector3(
    landmarks[10].x,
    landmarks[10].y,
    landmarks[10].z
  );

  const faceBottom = new THREE.Vector3(
    landmarks[152].x,
    landmarks[152].y,
    landmarks[152].z
  );

  const faceCenter = new THREE.Vector3(
    (landmarks[33].x + landmarks[263].x) * 0.5,
    (landmarks[33].y + landmarks[263].y) * 0.5,
    (landmarks[33].z + landmarks[263].z) * 0.5
  );

  const centered = landmarks.map(p => ({
    x: p.x - faceCenter.x,
    y: p.y - faceCenter.y,
    z: p.z - faceCenter.z,
  }));

  const height = faceBottom.distanceTo(faceTop);
  const scale = height === 0 ? 1 : 1 / height;

  const scaled = centered.map(p => ({
    x: p.x * scale,
    y: p.y * scale,
    z: p.z * scale,
  }));

  const currentDir = new THREE.Vector3().subVectors(faceBottom, faceTop).normalize();
  const targetDir = new THREE.Vector3(0, 1, 0);
  const quat = new THREE.Quaternion().setFromUnitVectors(currentDir,targetDir);

  const aligned = scaled.map(p => {
    const v = new THREE.Vector3(p.x, p.y, p.z);
    v.applyQuaternion(quat);
    return { x: v.x, y: v.y, z: v.z };
  });

  setData(_data => ({
    ..._data,
    mediaprocessing: {
      ..._data.mediaprocessing,
      [target]: {
        ..._data.mediaprocessing[target],
        face: {
          ..._data.mediaprocessing[target].face,
          cast: {
            ..._data.mediaprocessing[target].face.cast,
            landmarks: {
              ..._data.mediaprocessing[target].face.cast.landmarks,
              live: aligned,
            },
          },
        },
      },
    },
  }));
}

export default Align;